import Acknowledgements from "./Acknowledgements";

export const qaAcknowledgements = [
  {
    index: "acknowledgement1",
    question: "貢獻名單",
    answer: "",
    link: <Acknowledgements />,
  },
];
